export const getLocalStorage = <R>(key: string): R => JSON.parse(localStorage.getItem(`${key}`)!);

export const setLocalStorage = <T>(key: string, value: T): void => localStorage.setItem(`${key}`, JSON.stringify(value));

export const clearLocalStorage = (): void => localStorage.clear();

export const removeItemLocalStorage = (key: string | string[]): void => {
  const keys: string[] = (Array.isArray(key) ? key : [key]);
  keys.forEach((item) => localStorage.removeItem(`${item}`));
};
